import Div from '@ui/layout/Div'
import { func, string } from 'prop-types'
import Alert from '@ui/elements/Alert'

const FunctionType = ({ callback, cssClass, error }) => {
  return (
    <>
      <Div cssClass={`function-type ${cssClass}`}>{callback()}</Div>
      {error && <Alert cssClass='clear' type='is-danger' message={error} />}
    </>
  )
}

FunctionType.propTypes = {
  callback: func,
  cssClass: string,
  error: string
}

export default FunctionType
